module.exports = __webpack_public_path__ + "img/home-library-3.537f2633.png";